import React from 'react'
import styled from 'styled-components'

export const Isomorph = styled.div`
  position: absolute;
  height: 130px;
  width: 130px;
  transform: rotate3d(1, 0, 0, 45deg) rotate3d(0, 0, 1, -45deg);
`
